import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isGoogleAdsEnabled, loadGtagScript, gtagInit, gtagPageView } from '@/utilities/gtag';

/**
 * Google Ads / GA4 script'ini yükler, başlatır ve sayfa değişiminde page_view gönderir.
 * VITE_GA_MEASUREMENT_ID veya VITE_GOOGLE_ADS_ID tanımlıysa çalışır.
 */
const GoogleAds = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isGoogleAdsEnabled()) return;

    loadGtagScript().then(() => {
      gtagInit();
    });
  }, []);

  useEffect(() => {
    if (!isGoogleAdsEnabled()) return;
    gtagPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
};

export default GoogleAds;
